import { useQuery } from '@apollo/client/react'
import { useEffect } from 'react'

import { useNotification } from '~/src/components/shared/Notification/hooks/useNotification'
import { GET_NOTIFICATIONS_FOR_USER } from '~/src/components/shared/Notification/queries'
import {
  GetNotificationsForUserQuery,
  GetNotificationsForUserQueryVariables,
} from '~/src/components/shared/Notification/__generated_types__/queries.gql'

const useGetNotificationsForUser = (
  timeFloor: string,
  shouldQueryForNotifications: boolean
): void => {
  const { update } = useNotification() ?? {}

  const { data } = useQuery<
    GetNotificationsForUserQuery,
    GetNotificationsForUserQueryVariables
  >(GET_NOTIFICATIONS_FOR_USER, {
    variables: { timeFloor },
    skip: !shouldQueryForNotifications,
  })

  useEffect(() => {
    if (!data || !update) return

    update([...data.getNotificationsForUser])
  }, [data, update])
}

export default useGetNotificationsForUser
